import { useQContent } from '@exam-management/common/qcontent-provider';
import { useDisableQuestionMutation } from '@exam-management/graphql';
import { useSnackbar } from '@shared/snackbar';

import { type DisableQuestionModalProps, DisableQuestionModal } from '../../components';

type DisableSingleQuestionModalProps = Pick<DisableQuestionModalProps, 'open' | 'onClose'>;

export default function DisableSingleQuestionModal(
  props: Readonly<DisableSingleQuestionModalProps>,
) {
  const { open: isOpen, onClose } = props;

  const { qContent } = useQContent();
  const { showSnackbar } = useSnackbar();

  const [disableQuestion, { loading: isDisablingQuestion }] = useDisableQuestionMutation({
    onCompleted: () => {
      showSnackbar({ message: 'Question has been disabled', variant: 'success' });
      // NOTE: a workaround to close the modal
      onClose?.({} as React.MouseEvent<HTMLButtonElement>);
    },
    onError: () => {
      showSnackbar({ message: 'Unable to disable question', variant: 'error' });
    },
  });

  const handleAccept: React.MouseEventHandler<HTMLButtonElement> = async () => {
    await disableQuestion({ variables: { id: qContent.id } });
  };

  return (
    <DisableQuestionModal
      open={isOpen}
      onClose={onClose}
      onAccept={handleAccept}
      loading={isDisablingQuestion}
    />
  );
}
